export const roundUpToHundredth = (number) => {
    return Math.ceil(number * 100) / 100;
}